import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';

const styles = {
  checkbox: {
    marginLeft: 12,
  },
}

/**
 * Adds a group of checkboxes that are defined using props `values` and `descriptions`.
 * Returns an array of selected values using prop `onChange`
 */
class CheckboxGroup extends Component {
  state = {
    selectedDeviceTypes: this.props.values,
    deviceTypesToggle: false,
  }

  static propTypes = {
    values: PropTypes.array.isRequired,
    descriptions: PropTypes.array.isRequired,
    onChange: PropTypes.func,
  }

  componentWillMount() {
    this.props.onChange(this.state.selectedDeviceTypes);
  }

  /**
   * Selects or deselects all device types
   */
  toggleSelectAll = (event) => {
    let {deviceTypesToggle, selectedDeviceTypes} = this.state;
    
    selectedDeviceTypes = deviceTypesToggle ? this.props.values : [];
    deviceTypesToggle = !deviceTypesToggle;

    this.setState({
      selectedDeviceTypes,
      deviceTypesToggle,
    });
    this.props.onChange(selectedDeviceTypes);
  }

  /**
   * Handle checkbox updates.
   * We return a nested function, so that we can reuse the handler.
   */
  handleDeviceTypeSelectionChange = (cbId) => (event, isInputChecked) => {
    let {selectedDeviceTypes} = this.state;
    let {values} = this.props;

    // remove the entry from the list
    selectedDeviceTypes = selectedDeviceTypes.filter((value, index) => value === cbId ? false : true);

    // add again if needed
    if (isInputChecked) {
      selectedDeviceTypes.push(cbId);
    }

    // Update the `SELECT ALL/NONE` button to match the new selection
    let allSelected = values.length > selectedDeviceTypes.length ? false : true;
    const deviceTypesToggle = !allSelected;

    this.setState({
      selectedDeviceTypes,
      deviceTypesToggle,
    });
    this.props.onChange(selectedDeviceTypes);
  }
  
  render() {
    const {values, descriptions} = this.props;
    return (
      <div>
        {values.map((value, index) => (
          <Checkbox
            key={index}
            label={descriptions[index]}
            checked={this.state.selectedDeviceTypes.indexOf(value) !== -1}
            onCheck={this.handleDeviceTypeSelectionChange(value)}
            style={styles.checkbox}
          />
        ))}
        <br />
        <FlatButton label={`Select ${this.state.deviceTypesToggle?'all':'none'}`} onTouchTap={this.toggleSelectAll}/>
      </div>
    )
  }
}

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/CheckboxGroup/index.jsx